export default {
  colors: {
    text: '#fff',
    background: '#000',
    primary: '#fff',
    hover: '#333',
  },
  text: {
    code: {
      fontFamily: 'Menlo, monospace',
      fontSize: '0.9em',
      color: '#859900',
    },
  },
  badges: {
    outline: {
      color: 'rgb(255, 255, 255)',
      padding: '4px',
      fontWeight: 100,
      bg: 'transparent',
      boxShadow: 'inset 0 0 0 1px',
    },
  },
  buttons: {
    icon: {
      backgroundColor: 'transparent',
      color: 'primary',
      padding: 2,
      borderRadius: '50%',
      cursor: 'pointer',
      transition: 'background-color 0.2s',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
      },
    },
  },
  cards: {
    primary: {
      backgroundColor: 'background',
      borderRadius: '16px',
      overflow: 'hidden',
    },
  },
  styles: {
    hr: {
      borderTop: '1px solid',
      borderColor: 'rgba(255, 245, 220, 0.9)',
    },
    root: {
      fontFamily:
        'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
      backgroundColor: 'background',
      color: 'text',
    },
  },
  fonts: {
    body: 'system-ui, sans-serif',
    heading: 'system-ui, sans-serif',
    monospace: 'Menlo, monospace',
  },
  fontWeights: {
    body: 400,
    heading: 700,
    bold: 700,
  },
  lineHeights: {
    body: 1.5,
    heading: 1.125,
  },
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72],
};
